import React, { useEffect, useState } from "react";
import "./CalendarReminder.css";
import { useLocation } from "react-router-dom";
import DataTable from "react-data-table-component";

const CalendarReminder = () => {
  const [data, setData] = useState([]);
  const location = useLocation();
  const { date, reminder } = location?.state || {};
  console.log("date Object", date);
  console.log("type of data", typeof date);
  console.log("hello", new Date(date));
  console.log("reminders", reminder);

  // old function
  // function isSameDateOnlyPlusOne(date1, date2) {
  //   const addOneDay = (d) => {
  //     const newDate = new Date(d);
  //     newDate.setDate(newDate.getDate() + 1);
  //     return newDate;
  //   };

  //   const formatDateOnly = (d) => new Date(d).toISOString().slice(0, 10);

  //   const date1PlusOne = addOneDay(date1);
  //   return formatDateOnly(date1PlusOne) === formatDateOnly(date2);
  // }

  // new function
  function isSameDateOnlyPlusOne(date1, date2) {
    // Convert both dates to UTC date strings for comparison
    const formatUTCDateOnly = (d) => {
      const date = new Date(d);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    // Create date1 plus one day in UTC
    const date1Obj = new Date(date1);
    date1Obj.setUTCDate(date1Obj.getUTCDate() + 1);

    return formatUTCDateOnly(date1Obj) === formatUTCDateOnly(date2);
  }

  const matchTheReminderWithDate = () => {
    const foundReminder = reminder?.find((e) => {
      return isSameDateOnlyPlusOne(date, e?.calenderDate);
    });
    console.log("found Reminder", foundReminder?.noteData);
    setData(foundReminder?.noteData);
  };

  useEffect(() => {
    matchTheReminderWithDate();
  }, []);

  // const user = {
  //   name: "Amit Roy",
  //   id: "1258967485hhhh695dd",
  //   phone: "1234567890",
  //   email: "abc@gmail.com",
  //   notes:
  //     "Hey! Just a quick reminder to check on your visa renewal. Dont let the deadline sneak up—better to sort it out early!",
  // };

  const columns = [
    {
      name: "Sl NO",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "Customer ID",
      selector: (row) => row?.customerNo,
    },
    {
      name: "User Name",
      selector: (row) => row?.userName,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row?.userEmail,
      sortable: true,
      wrap: true,
    },
    {
      name: "Notes",
      selector: (row) => row?.notes,
      sortable: true,
      wrap: true,
    },
    {
      name: "Added By",
      selector: (row) => row?.addedByAdminName || row?.addedByStaffName,
      sortable: true,
      wrap: true,
    },
  ];

  const formatDateWithOrdinal = (inputDate) => {
    if (!inputDate) return "";

    const date = new Date(inputDate);

    if (isNaN(date)) return "Invalid Date";

    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return "th";
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "100px" }}>
        {/* <div className="user-card">
          <h2 className="user-card__name">{user?.name}</h2>
          <p>
            <strong>User ID:</strong> {user?.id}
          </p>
          <p>
            <strong>Phone:</strong> {user?.phone}
          </p>
          <p>
            <strong>Email:</strong> {user?.email}
          </p>
          <p>
            <strong>Notes:</strong>{" "}
          </p>
          <p className="user-card__notes">{user?.notes}</p>
        </div> */}
        <div
          style={{
            textAlign: "center",
            fontSize: "24px",
            color: "#ff9c00",
            marginBottom: "15px",
            fontWeight: "700",
          }}
        >
          {formatDateWithOrdinal(date)}
        </div>
        <DataTable data={data} columns={columns} />
      </div>
    </>
  );
};

export default CalendarReminder;
